import Mock from 'mockjs'
// 获取 mock.Random 对象
const Random = Mock.Random

const testone = () => {
  let testlist = []
  for (let i = 0; i < 3; i++) {
    let datalist = {
      userNo: Random.id(),
      wechart: Random.cname(),
      userTel: Random.natural(1, 200),
      cj: Random.natural(1, 100),
      cash: Random.natural(100, 9000),
      date: Random.date(),
      lastdate: Random.date(),
      state: Random.natural(1, 3),
      name: Random.cname(),
      address: '上海市普陀区金沙江路 1518 弄'
    }
    testlist.push(datalist)
  }
  return {
    testlist: testlist
  }
}

const testone1 = () => {
  let testlist = []
  for (let i = 0; i < 6; i++) {
    let datalist = {
      date: Random.date(),
      userage: Random.natural(20, 50),
      userheight: Random.natural(150, 190),
      userweight: Random.natural(40, 80),
      usersanwei: Random.natural(60, 90) + '/' + Random.natural(60, 90) + '/' + Random.natural(60, 90),
      userjian: '肩',
      userfu: '腹',
      userbei: '背',
      userlag: '腿',
      username: Random.cname(),
      pics: [
        {url: require('@/assets/logo.png')},
        {url: require('@/assets/logo.png')}
      ],
      bz: ['2', '3', '4', {bz: '5'}]
    }
    testlist.push(datalist)
  }
  return {
    testlist: testlist
  }
}

const goodstypes = () => {
  let testlist = {
    goodstype1: [
      { name: 'fuz1',
        sub: [
          { name: 'fuz4',
            sub: [
              { name: 'fuz6', sub: [] }
            ]
          },
          {name: 'fu5', sub: []}
        ]
      },
      {name: 'fuz2', sub: []},
      {name: 'fuz3', sub: []}
    ]
  }
  return {testlist: testlist}
}

const goodsperiods = () => {
  let testlist = {
    goodstype1: [
      { id: '1', // 期数
        sub: [

        ],
        time: '1'
      },
      { id: '2', // 期数
        sub: [
          {id: '3', name: 'fu5'}, // 商品1编号,商品1名称
          {id: '4', name: 'fxx'}
        ],
        time: '1'
      },
      { id: '3', // 期数
        sub: [
          {id: '5', name: 'fu5'}, // 商品1编号,商品1名称
          {id: '6', name: 'fxx'}
        ],
        time: '2'
      }
    ]
  }
  return {testlist: testlist}
}

const goodsperiods1 = () => {
  let testlist = {
    goodstype1: [
      { id: '2', // 期数
        sub: [
          {id: '3', name: 'fu5', price: 100, cashtype: '定金', minnum: 5, shownum: 2}, // 商品1编号,商品1名称
          {id: '4', name: 'fxx', price: 100, cashtype: '定金', minnum: 5, shownum: 2}
        ],
        time: '1'
      }
    ]
  }
  return {testlist: testlist}
}

const goods1 = () => {
  let testlist = {
    goods: [
      { id: '2', // 商品号
        type: 'fengyi',
        name: 'xxx', // 商品名称
        dic: '22222',
        state: 1,
        paystate: 2,
        num: 800,
        likenum: 200,
        zcnum: 100,
        upstate: 2,
        slimg: {
          picid: 1,
          picurl: '../../static/img/bg.jpg'
        },
        hbimg: {
          picid: 1,
          picurl: ''
        },
        xqimg: {
          picid: 1,
          picurl: '../../static/img/bg.jpg'
        },
        bj: [
          {
            id: 3,
            name: '领口',
            ys: [
              {
                name: '圆领',
                picurl: '../../static/img/bg.jpg',
                ysid: 1,
                sm: '1'// 说明
              },
              {
                name: '鸡心领',
                picurl: '',
                ysid: 2,
                sm: '2'// 说明
              }
            ]
          },
          {
            id: 4,
            name: '袖口纽扣',
            ys: [
              {
                name: '单纽扣',
                picurl: '',
                ysid: 3,
                sm: '3'// 说明
              },
              {
                name: '双纽扣',
                picurl: '',
                ysid: 5,
                sm: '4'// 说明
              },
              {
                name: '三纽扣',
                picurl: '',
                ysid: 6,
                sm: '5'// 说明
              }
            ]
          }
        ],
        kxz: [
          {
            id: 3,
            name: '左袖口',
            sub: [
              {
                id: 1,
                bjname: '领口',
                bjid: 3,
                ysname: '圆领',
                ysid: 1

              },
              {
                id: 2,
                bjname: '领口',
                bjid: 3,
                ysname: '鸡心领',
                ysid: 2
              }
            ],
            picid: 1,
            picurl: ''
          }
        ],
        mrk: [
          {id: 1,
            item: [
              { bjid: 3,
                bjys: 1},
              { bjid: 4,
                bjys: 3}
            ]
          },
          {id: 2,
            item: [
              { bjid: 3,
                bjys: 2},
              { bjid: 4,
                bjys: 3}
            ]
          }
        ],
        xzcolor: [
          {
            id: 1,
            colorname: '象牙白',
            picid: 1,
            picurl: ''
          }
        ],
        zc: {
          zcnum: 20,
          fhtime: 10,
          zccashtype: 1,
          price: 3000,
          tkkd: 20
        },
        time: '1'
      }
    ]
  }
  return {testlist: testlist}
}

const testone3 = () => {
  let testlist = []
  for (let i = 0; i < 3; i++) {
    let datalist = {
      periodNo: Random.id(),
      goodNo: Random.id(),
      goodName: Random.cname(),
      price: Random.natural(500, 10000),
      num: Random.natural(100, 10000),
      likenum: Random.natural(1, 100),
      zcnum: Random.natural(1, 90),
      startdate: Random.date(),
      zcdate: Random.date(),
      state: Random.natural(1, 3),
      paystate: Random.natural(1, 3),
      name: Random.cname(),
      upstate: 2

    }
    testlist.push(datalist)
  }
  return {
    testlist: testlist
  }
}

const banner1 = () => {
  let testlist = []
  for (let i = 0; i < 3; i++) {
    let datalist = {
      periodNo: Random.id(),
      goodNo: Random.id(),
      goodName: Random.cname()
    }
    testlist.push(datalist)
  }
  return {
    testlist: testlist
  }
}
Mock.mock('/api/brew/user', 'get', testone)
Mock.mock('/api/brew/usersize', 'get', testone1)
Mock.mock('/api/brew/crowdgood', 'get', testone3)
Mock.mock('/api/brew/goodstype', 'get', goodstypes)
Mock.mock('/api/brew/goodsperiodslist', 'get', goodsperiods)
Mock.mock('/api/brew/goodsperiods', 'get', goodsperiods1)
Mock.mock('/api/brew/good', 'get', goods1)
Mock.mock('/api/brew/banner', 'get', banner1)
// Mock.mock('/api/user/info', 'get', [{id: '1', name: 'admin'}])



// WEBPACK FOOTER //
// ./src/mock.js